import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { getTransportSelector } from '@/scopes/prices/components/selectors'
import { FlightSelectorDesktop } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorDesktop'
import { FlightSelectorMobile } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorMobile'
import { FlightTypeInfo } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightTypeInfo'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './index.module.css'

function FlightSelector() {
  const intl = useIntl()
  const { isDesktopSm } = useBreakpoints()
  const { error } = usePricesSelector(getTransportSelector)

  if (error) {
    return (
      <Dialog
        text={intl.formatMessage({ id: 'prices_flight_selector_error_title' })}
        supportingText={intl.formatMessage({ id: 'prices_flight_selector_error_message' })}
        type="alert"
      >
        <Button onClick={() => window.location.reload()}>
          {intl.formatMessage({ id: 'prices_error_reload_button' })}
        </Button>
      </Dialog>
    )
  }

  return (
    <div className={styles.wrapper}>
      {isDesktopSm
        ? <FlightSelectorDesktop />
        : <FlightSelectorMobile />}
      <FlightTypeInfo />
    </div>
  )
}

export { FlightSelector }
